module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Regular.1f45a43.eot";